<app-calendar-create-event-activity [entity]="entity" (create)="setAndSubmit($event)" (formReset)="close()" [showPreviousStep]="false"></app-calendar-create-event-activity>
